<template>
    <div id="SMFDownloads">
        <div class="container">

            <h1>{{ $t('downloads')}}</h1>

            <b-card-group deck style="margin-top:2rem; margin-bottom:2rem;">
                <b-card title="SMF Manual (deutsch)"
                        img-src="iconmonstr-book-20.svg">
                    <b-button variant="primary" @click="download('manual-de.html', 'manual.html')">download (5.3 MB)</b-button>
                </b-card>
                <b-card title="SMF Manual (english)"
                        img-src="iconmonstr-book-20.svg">
                    <b-button variant="primary" @click="download('manual-en.html', 'manual.html')">download (5.3 MB)</b-button>
                </b-card>
                <b-card title="SMF Manual (online)"
                        img-src="iconmonstr-link-1.svg">
                    <b-button variant="primary" to='/software'>SMF Manual (online)</b-button>
                </b-card>
                <b-card title="SMF Product Sheet"
                        img-src="iconmonstr-note-25.svg">
                    <b-button variant="primary" @click="download('SMF-v7-product-sheet.pdf', 'SMF-product-sheet.pdf')">download (2.7 MB)</b-button>
                </b-card>
                <b-card title="Gateway Architecture"
                        img-src="iconmonstr-share-1.svg">
                    <b-button variant="primary" @click="download('gateway-architecture.pdf', 'SMF-gateway-architecture.pdf')">download (3.8 MB)</b-button>
                </b-card>
                <b-card title="SMF Software" img-src="iconmonstr-note-25.svg">
                    <b-button variant="primary" @click="download('gateway-foundation.pdf', 'SMF-software.pdf')">download (646 kB)</b-button>
                </b-card>
            </b-card-group>

            <b-card-group deck style="margin-top:2rem; margin-bottom:2rem;">
                <b-card title="LoRa Manual"
                        img-src="iconmonstr-wireless-7.svg">
                    <b-button variant="primary" @click="download('SMF-v7-LoRa.pdf', 'SMF-LoRa.pdf')">download (3.6 MB)</b-button>
                </b-card>
                <b-card title="Operation"
                        img-src="iconmonstr-book-20.svg">
                    <b-button variant="primary" @click="download('operation-v0.7.pdf', 'operation.pdf')">download (1.4 MB)</b-button>
                </b-card>
                <b-card title="Curriculum Vitae"
                        img-src="iconmonstr-note-15.svg">
                    <b-button variant="primary" @click="download('cv.pdf', 'cv.pdf')">download (592 kB)</b-button>
                </b-card>
                <b-card title="Smart Metering Gateway"
                        img-src="iconmonstr-window-21.svg">
                    <b-button variant="primary" @click="download('hardware-de-full.html', 'hardware.html')">download (1.3 MB)</b-button>
                </b-card>
                <b-card title="AGB Hosting"
                        img-src="iconmonstr-script-3.svg">
                    <b-button variant="primary" @click="download('AGB-Hosting.pdf', 'AGB-Hosting.pdf')">download (223 kB)</b-button>
                </b-card>
                <b-card title="AGB Wartungsvertrag"
                        img-src="iconmonstr-script-3.svg">
                    <b-button variant="primary" @click="download('AGB-Wartungsvertrag.pdf', 'AGB-Wartungsvertrag.pdf')">download (404 kB)</b-button>
                </b-card>
            </b-card-group>

        </div>
    </div>
</template>

<script>

    export default {
        name: 'Downloads',
        data() {
            return {
                // url: 'https://78.media.tumblr.com/tumblr_m39nv7PcCU1r326q7o1_500.png'
                url: 'SMF-v7-product-sheet.pdf'
            }
        },
        methods: {
            forceFileDownload(response, file) {
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', file) // or any other extension
                document.body.appendChild(link)
                link.click()
            },

            download(url, file) {
                this.$http.get(url, { timeout: 0, responseType: 'arraybuffer' }).then(response => {
                    this.forceFileDownload(response, file)
                })
            },
            downloadWithVueResource() {
                this.$http({
                    method: 'get',
                    url: this.url,
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        this.forceFileDownload(response)
                    })
                    .catch(() => console.log('error occured'))
            }
        }
    }
</script>

<style scoped lang="css">
      figure {
          margin: 2%;
      }

      aside {
          float: right;
          width: 20%;
          text-align: center;
      }

      .docscript-img {
          max-width: 95%;
          border: 2px solid #777;
      }

          .docscript-img:hover {
              box-shadow: 0 0 10px #ccc;
          }

      .docscript-footnote {
          margin-bottom: 0rem;
      }
      /* #SMFDownloads {
      background: rgb(220,226,226);
    } */
      /* .card-img-bottom {
      width: 50% !important;
    } */
      .card-body {
          display: flex;
          flex-direction: column;
      }

      button.btn {
          margin-top: auto;
      }
</style>
